import React from "react";
import { makeStyles } from "@mui/styles";
import { HeaderMenu } from "../components/Header";
import { MobileWeb } from "../components/mobile/BreakPoint";
import { Theme } from "@mui/material";
import { Footer } from "../components/Footer";
import { MobileFooter } from "../components/mobile/MobileFooter";
import { Typography } from "../components/Typography";
import elderyIntro1 from "../asset/elderyIntro1.png";
import elderyIntro2 from "../asset/elderyIntro2.png";
import halfCircleBlue from "../asset/half_circle_blue.png";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",

    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      margin: "0px",
      height: "auto",
      minHeight: "auto",
    },
  },
  body: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignSelf: "center",
    height: "100vh",
    minHeight: 800,
    justifyContent: "center",
    alignItems: "center",
    borderTop: "1px solid #0000003b",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      height: "100%",
      borderTop: "none",
    },
  },
  container1: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    marginTop: 50,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      flexDirection: "column",
    },
  },
  top_text: {
    position: "relative",
    display: "flex",
    justifyContent: "flex-start",
    color: "#204FA1",
    maxWidth: 1290,
    fontSize: 18,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      fontSize: 18,

      justifyContent: "flex-start",
      marginLeft: 50,
    },
  },
  textBox1: {
    width: 628,
    alignSelf: "center",
    position: "relative",
    marginBottom: 20,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      marginBottom: 20,
      textAlign: "justify",
    },
  },
  subtextBox: {
    wordBreak: "break-word",
    textAlign: "justify",
    width: 634,
    height: 435,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      width: "90%",
      margin: "0px 20px",
      wordBreak: "keep-all",
    },
  },
  imgBox: {
    position: "relative",
    margin: "50px 0px",
    textAlign: "center",
    width: "100%",
    background: "#fdf5fd",
    height: 130,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down(MobileWeb.mobile)]: {},
  },
  img: {
    position: "relative",
    bottom: 100,
    left: 75,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      left: 49,
      bottom: 30,
      width: 330,
      height: "auto",
    },
  },
  img2: {
    position: "relative",
    bottom: 80,
    right: 275,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      height: 150,
      left: -151,
      bottom: 16,
    },
  },
  halfCircleBlue: {
    position: "relative",
    bottom: 5,
    right: 30,
    width: 65,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      right: 0,
      bottom: 5,
      marginLeft: 20,
    },
  },
}));

const ElderyIntroPage = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <HeaderMenu />
      <div className={classes.body}>
        <div className={classes.textBox1}>
          <img
            src={halfCircleBlue}
            alt="blueHalfCircle"
            className={classes.halfCircleBlue}
          />
          <Typography variant="H3" className={classes.top_text}>
            사업소개
          </Typography>
        </div>
        <div className={classes.subtextBox}>
          <Typography variant="mbaContent">
            전 세계적으로 급속히 늘어나는 노인들을 대상으로 한 다양하고 전문적인
            케어 서비스의 관심과 필요성이 큰 화두로 제기됨에 따라 글로벌 노인
            요양 및 간호서비스 제공자 교육을 위한 강사 양성을 위한 체계적인 전문
            교육 과정을 운영합니다. K-Silver CARE e SCHOOL 노인의 돌봄 기술,
            중국의 역사, 문화, 중국 노인의 주요 건강 문제, 효과적인 멘토 멘티
            교수법, 중국과의 현장 케이스 컨퍼런스 과정으로 이론/ 실시/ 실습
            과정으로 진행됩니다.
            <br />
            <br />
            전문 강사 양성을 위한 K-Silver CARE e SCHOOL은 현직 교수진을
            중심으로 하여 전문의, 노인장기요양 기관장 및 시설장, 중국 현지파트너
            기관(만학교육)의 교육 책임자의 강의를 토대로 한국의 노인장기요양
            실무경력자를 대상으로 교육을 진행했으며 2021년 11월 고령친화 해외
            진출 전문인력을 배출하였습니다.
          </Typography>
        </div>

        <div className={classes.imgBox}>
          <img
            src={elderyIntro1}
            alt="elderyIntro1"
            className={classes.img}
          ></img>
          <img
            src={elderyIntro2}
            alt="elderyIntro2"
            className={classes.img2}
          ></img>
        </div>
      </div>
      <Footer />
      <div style={{ display: "flex" }}>
        <MobileFooter />
      </div>
    </div>
  );
};

export default ElderyIntroPage;
